export default {
  white: '#fff',
  black: '#000',
  ultraLightGrey: '#e0e0e0',
  grey: '#bebebe',
  darkGrey: '#7e7e7e',
  pink: '#E20451',
};
